// The improved version of the My Intrivity Application
import { html, css, LitElement } from 'lit-element';
import { unsafeHTML } from 'lit-html/directives/unsafe-html.js';
import { clone, cloneDeep } from 'lodash-es';
import { library, dom } from "@fortawesome/fontawesome-svg-core";   

import './behaviors_app.js';
import { 
    getScore, getIcon, getColor, feedback_mapping 
} from './utility.js'
import { a11yStyles, disclosureButton, uniqueId, accessibleTextColor } from './a11y.js';
import { t, Localized } from './i18n.js';

export class IntrivityCharacteristics extends Localized(LitElement) {

    static get styles() {
        return [a11yStyles, css`
            /* Was a styled <div>; now a real heading so the report has a
               navigable structure (WCAG 1.3.1, 2.4.6). Black on #808080 is
               5.3:1, which clears AA. */
            .section-header {
                margin: 0 0 5px 0;
                width: 100%;
                box-sizing: border-box;
                color: black;
                font-size: 1.5em;
                font-weight: normal;
                padding: 15px 10px 10px 30px;
                background-color: gray;
            }
            .section-header .disclosure {
                vertical-align: middle;
                margin-left: 8px;
                padding: 4px;
            }
        `];
    }

    static get properties() {
        return {
            domain: { type: Object },
            domain_prefix: { type: String },
            report: { type: Object },
            group_report: { type: Object },
            expanded: { type: Boolean },
            printable: { type: Boolean }
        };
    }

    constructor() {
        super();
        this._panelId = uniqueId('characteristics');
        this.getRawScore = this.getRawScore.bind(this);
        this.expanded = false;
    }

    connectedCallback() {
        super.connectedCallback();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }
    
    getRawScore(i) {
        console.log(this.report[this.domain.code].level_two[i].average);
        return this.report[this.domain.code].level_two[i].average;
    }
    
    getTeamScore(i) {
        let groups = [];
        if (this.group_report) {
            let max = 1;
            for (let key in this.group_report[this.domain.code].level_two[i].responses) {
                if (this.group_report[this.domain.code].level_two[i].responses.hasOwnProperty(key)) {
                    let group = {};
                    group.score = Number(key).toFixed(1);
                    group.size = this.group_report[this.domain.code].level_two[i].responses[key].length;
                    if (max < group.size) max = group.size;
                    group.weight = this.group_report[this.domain.code].level_two[i].responses[key].length * 5;
                    groups.push(group);
                }
            }
            for (let i=0; i < groups.length; i++) {
                groups[i].max = max;
            }
            //group.score = this.group_report[this.domain.code].level_two[i].average;
            //group.size = this.group_report.users.length;
            //group.weight = 5; //??
            //groups.push(group);
        }
        return groups;
        //return JSON.stringify(groups);       
    }
    
    render() {
        return html`
            <h2 class="section-header">
                ${t('domainDetails.characteristic')}
                ${this.printable ? html``: disclosureButton(this.expanded, t('domainDetails.characteristics'), this._panelId, () => { this.expanded = !this.expanded; })}
            </h2>
        
            ${this.expanded || this.printable ? html`
                <div id=${this._panelId} style="width: 100%;">
                    ${this.domain.level_two.map((characteristic, i) => 
                        html`
                            <div style="display: grid; grid-template-columns: 1fr 2fr; width: 100%; margin: 20px;">
                                <div style="margin: 20px;">
                                    <h3 style="font-weight: normal; margin: 0 0 15px 0; color: ${accessibleTextColor(this.domain.color)}; font-size: 1.6em;">
                                        ${characteristic.name.toUpperCase()}     
                                    </h3>
                                    <div>${characteristic.description}</div>
                                </div>
                                <div style="margin: 20px;">                                    
                                    <intrivity-likert-report .size_max=${this.group_report.num} .right_text=${characteristic.right_label} .left_text=${characteristic.left_label} .you="${this.getRawScore(i)}" .groups=${this.getTeamScore(i)} .color=${this.domain.color} .colorhue=${this.domain.colorhue} .colorsat=${this.domain.colorsat} .colorlight=${this.domain.colorlight}></intrivity-likert-report>                                    
                                    <div style="margin: 5%;">${characteristic.feedback[feedback_mapping[getScore(this.getRawScore(i)) - 1]]}</div>
                                </div>
                            </div>
                         
                            <div style="margin: 10px;">
                                <intrivity-behaviors .printable=${this.printable} .group_report=${this.group_report} .characteristic=${characteristic} .characterestic_index="${i}" .domain=${this.domain} .domain_prefix=${this.domain_prefix} .report=${this.report}></intrivity-behaviors>
                            </div>
        
                            <hr />
                        `
                    )}
            
                </div>    
            `: html``}
        `
    } 
 
}
if (!customElements.get('intrivity-characteristics')) customElements.define('intrivity-characteristics', IntrivityCharacteristics);
